import { useRouter } from "next/compat/router";
import { useEffect, useRef, useState } from "react";
import { connectSortBy } from 'react-instantsearch-dom';
import styles from './SortByComp.module.scss'
const SortByFilter = ({ items, refine, createURL, pathnameRouter, repalceRoute }) => {
  const sortByWrapper = useRef()
  const handleDropdown = () => {

    let target = sortByWrapper.current
    target.classList.toggle(`${styles.active}`)
  }
  return (
    <div className={`sort-by-txt ${styles.sort_by_wrapper}`} ref={sortByWrapper} >
      <div className={`${styles.sort_by_backdrop}`} onClick={handleDropdown}></div>
      <div className={`${styles.sort_by_header} large-md normal-sm small-xs light-md`} onClick={handleDropdown} id="sort-handle-button-desktop">
        Sort by<span className={`${styles.xs_hide}`}>:</span>
        <div className={`small-md small-sm ${styles.sort__active_cta}`}><span className={`${styles.active__cta_title}`}>{items.map(item => item.isRefined && `${item.label}`)}</span>
          <div className={`py-1 ${styles.down_arrow}`}>
            <svg width="17" height="10" viewBox="0 0 17 10" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(-1 0 0 1 15.7 1) matrix(-1 0 0 1 14 0)" stroke="#2F2F30" strokeWidth="1.4" fill="none" fillRule="evenodd" strokeLinecap="round"><path transform="matrix(0 1 1 0 -.5 .5)" d="M-.5.5 7.5 7.5" /><path transform="matrix(0 1 1 0 6.4 -6.4)" d="M6.4 7.5 14.4.5" /></g></svg>
          </div>
        </div>
      </div>
      <div className={`${styles.sort_dropdown}`}>
        <div className={`${styles.sort_sub_header}`} id="sort-handle-button-mobile" onClick={handleDropdown}>
          <span className="small-xs">Sort by</span>
          <div className={`py-1 ${styles.down_arrow} ${styles.mob_down_arrow}`}>
            <svg width="17" height="10" viewBox="0 0 17 10" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(-1 0 0 1 15.7 1) matrix(-1 0 0 1 14 0)" stroke="#2F2F30" strokeWidth="1.4" fill="none" fillRule="evenodd" strokeLinecap="round"><path transform="matrix(0 1 1 0 -.5 .5)" d="M-.5.5 7.5 7.5" /><path transform="matrix(0 1 1 0 6.4 -6.4)" d="M6.4 7.5 14.4.5" /></g></svg>
          </div>
        </div>
        <ul className={`${styles.sort__dropdonw_wrapper}`} id={`sort-ul-tag`}>
          {items.map(item => (
            <li key={item.value} id={`sort-li-${item.value}`}>
              <a
                className={`x-small-md x-small-sm small-xs ${styles.sort__dropdown_cta}${item.isRefined ? ` ${styles.active__cta}` : ''}`}
                href={createURL(item.value)}
                id={`sort-a-tag-${item.value}`}
                onClick={event => {
                  handleDropdown()
                  event.preventDefault();
                  refine(item.value);
                  sessionStorage.setItem(`${pathnameRouter}~sort_by`, item.value)
                  repalceRoute()
                }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>

  )
}

const CustomSortBy = connectSortBy(SortByFilter);

const SortByComp = ({ type = '' }) => {
  const [sortByCookie, setSortByCookie] = useState('')

  let sortBy = '';
  const router = useRouter();

  function repalceRoute() {
    // router.replace({query: {...router.query, action: 'retain'}}, undefined, {scroll: false})
  }

  let pathnameRouter = router.pathname
  if(pathnameRouter === "/[...pages]") {
    pathnameRouter = router.query.pages.join('/')
  }
  const { sort_by } = router.query;
  useEffect(() => {

    setSortByCookie(sessionStorage.getItem(`${pathnameRouter}~sort_by`))
  }, [])
  const sort_arr = {
    'price_asc': process.env.SHOPIFY_PRICE_ASC_INDEX,
    'price_desc': process.env.SHOPIFY_PRICE_DESC_INDEX,
    'featured': process.env.SHOPIFY_PRIMARY_INDEX,
    'newest': process.env.SHOPIFY_NEWEST_FIRST_INDEX,
  };

  let sortByDefault = sort_by ? sort_arr[`${sort_by}`] : '';
  if(sortByCookie) {
    sortByDefault = sortByCookie
  }
  if (type === 'sale') {
    sortBy = <CustomSortBy id='sort-by-dropdown' 
    repalceRoute = {repalceRoute}
      pathnameRouter = {pathnameRouter}
      defaultRefinement={(sortByDefault) ? sortByDefault : process.env.SHOPIFY_PRIMARY_INDEX}
      items={[
        { value: process.env.SHOPIFY_PRIMARY_INDEX, label: 'Featured' },
        { value: process.env.SHOPIFY_NEWEST_FIRST_INDEX, label: 'Newest First' },
        // { value: 'shopify_stagedataproducts_sale', label: 'Discount High to Low' },
        { value: process.env.SHOPIFY_PRICE_DESC_INDEX, label: 'Price High to Low' },
        { value: process.env.SHOPIFY_PRICE_ASC_INDEX, label: 'Price Low to High' },
      ]} />
  } else if (type === 'newest') {
    sortBy = <CustomSortBy id='sort-by-dropdown' 
    repalceRoute = {repalceRoute}
      pathnameRouter = {pathnameRouter}
      defaultRefinement={(sortByDefault) ? sortByDefault : process.env.SHOPIFY_NEWEST_FIRST_INDEX}
      items={[
        { value: process.env.SHOPIFY_NEWEST_FIRST_INDEX, label: 'Featured' },
        { value: process.env.SHOPIFY_PRICE_DESC_INDEX, label: 'Price High to Low' },
        { value: process.env.SHOPIFY_PRICE_ASC_INDEX, label: 'Price Low to High' },
      ]} />
  } else if (type === 'designer') {
    sortBy = <CustomSortBy id='sort-by-dropdown' 
    repalceRoute={repalceRoute}
      pathnameRouter = {pathnameRouter}
      defaultRefinement={(sortByDefault) ? sortByDefault : process.env.SHOPIFY_PRIMARY_INDEX}
      items={[
        { value: process.env.SHOPIFY_PRIMARY_INDEX, label: "Featured" },
        {
          value: process.env.SHOPIFY_PRICE_DESC_INDEX,
          label: "Price High to Low",
        },
        {
          value: process.env.SHOPIFY_PRICE_ASC_INDEX,
          label: "Price Low to High",
        },
      ]} />
  }
  else if (type === 'trends') {
    sortBy = <CustomSortBy id='sort-by-dropdown'
    repalceRoute={repalceRoute}
    pathnameRouter = {pathnameRouter}
    defaultRefinement={(sortByDefault) ? sortByDefault : process.env.SHOPIFY_PRIMARY_INDEX}
      items={[
        { value: process.env.SHOPIFY_PRIMARY_INDEX, label: "Featured" },
        {
          value: process.env.SHOPIFY_PRICE_DESC_INDEX,
          label: "Price High to Low",
        },
        {
          value: process.env.SHOPIFY_PRICE_ASC_INDEX,
          label: "Price Low to High",
        },
      ]} />
  } else {
    sortBy = <CustomSortBy id='sort-by-dropdown'
    repalceRoute={repalceRoute}
      pathnameRouter = {pathnameRouter} 
      defaultRefinement={(sortByDefault) ? sortByDefault : process.env.SHOPIFY_PRIMARY_INDEX}
      items={[
        { value: process.env.SHOPIFY_PRIMARY_INDEX, label: "Featured" },
        {
          value: process.env.SHOPIFY_NEWEST_FIRST_INDEX,
          label: "Newest First",
        },
        {
          value: process.env.SHOPIFY_PRICE_DESC_INDEX,
          label: "Price High to Low",
        },
        {
          value: process.env.SHOPIFY_PRICE_ASC_INDEX,
          label: "Price Low to High",
        },
      ]} />
  }


  return (
    <>
      {sortBy}
    </>
  );
};



export default SortByComp;


